<script lang="ts" setup>
import { ref } from 'vue';

import ErrorCaption from '@/profile/components/error-caption.component.vue';
import type { ValidationOptions } from '@/common/validators/validation-options.type.ts';

const errorMessage = ref('');
const { label, field, value, validator } = defineProps<{
  label: string;
  field: string;
  value: string | undefined;
  validator?: (validationOptions: ValidationOptions) => ValidationOptions;
}>();
const emit = defineEmits(['update', 'error']);

function handleUpdate(e: Event) {
  const inputValue = (e.target as HTMLInputElement).value;
  emit('update', { [field]: inputValue });
  if (validator) {
    const result = validator({ value: inputValue });
    errorMessage.value = '';
    if (result.code) {
      emit('error', `${field}:${result.code}`);
      if (result.message) {
        errorMessage.value = result.message(field);
      }
    }
  }
}
</script>

<template>
  <div class="mt-4 flex flex-col">
    <label :data-testid="field + '-label'" :for="field">{{ label }}</label>
    <input
      :id="field"
      :data-testid="field + '-input'"
      :value="value"
      class="border"
      @input="handleUpdate"
    />
    <error-caption :data-testid="`${field}:error`" :error="errorMessage" />
  </div>
</template>

<style scoped></style>
